import React from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";

const DEFAULT_TIMEZONE = "Europe/London";
const DATE_FORMAT = "DD MMM YYYY";
const TIME_FORMAT = "hh:mm A";

const DateTime = ({
  date,
  showDate = true,
  showTime = true,
  timezone = DEFAULT_TIMEZONE,
  dateFormat = DATE_FORMAT,
  timeFormat = TIME_FORMAT,
}) => {
  if (!date) return <span>-</span>;

  const m = moment(date).tz(timezone);

  return (
    <span className="datetime-wrapper">
      {showDate && (
        <span className="u-before-icon-calendar2">
          &nbsp;&nbsp;{m.format(dateFormat)}
        </span>
      )}
      {showDate && showTime && <br />}
      {showTime && (
        <span className="u-before-icon-clock text-sm text-gray-600">
          &nbsp;&nbsp;{m.format(timeFormat)}
        </span>
      )}
    </span>
  );
};

DateTime.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  showDate: PropTypes.bool,
  showTime: PropTypes.bool,
  timezone: PropTypes.string,
  dateFormat: PropTypes.string,
  timeFormat: PropTypes.string,
};

export default DateTime;
